module.exports = __webpack_public_path__ + "media/images/Icotype_puce-e9871e9ed5bf3ee594aa9c5f45c6dbad.svg";